import { lazy, Suspense } from "react";
import { SkeletonPage } from "@/components/SkeletonLoaders.jsx";
import { Navigate } from "react-router-dom";

const Loadable = (Component) => (props) => (
  <Suspense fallback={<SkeletonPage />}>
    <Component {...props} />
  </Suspense>
);

// Lazy-loaded screens
const CarWashHome = Loadable(lazy(() => import("./pages/Home.jsx")));
const VehicleType = Loadable(lazy(() => import("./pages/VehicleType.jsx")));
const VehicleBrand = Loadable(lazy(() => import("./pages/VehicleBrand.jsx")));
const SelectVehicle = Loadable(lazy(() => import("./pages/SelectVehicle.jsx")));
const WashDetails = Loadable(lazy(() => import("./pages/WashDetails.jsx")));
const Cart = Loadable(lazy(() => import("./pages/Cart.jsx")));
const SlotBook = Loadable(lazy(() => import("./pages/SlotBook.jsx")));
const CarWashList = Loadable(lazy(() => import("./pages/CarWashList.jsx")));
const Summary = Loadable(lazy(() => import("./pages/Summary.jsx")));
const ThanksPage = Loadable(lazy(() => import("./pages/ThanksPage.jsx")));
const SubscriptionDetailsPage = Loadable(lazy(() => import("./pages/SubscriptionDetailsPage.jsx")));


// All Car Wash Routes - Nested structure like salon and food
const carWashRoutes = [
  {
    path: "carwash",
    children: [
      {
        index: true,
        element: <Navigate to="6" replace />, // Default to category 4 (Car Wash)
      },
      // Home/Landing page with category
      {
        path: ":category_id",
        element: <CarWashHome />,
      },
      // Services list for a category
      {
        path: ":category_id/services",
        element: <CarWashList />,
      },
      // Vehicle selection flow
      {
        path: ":category_id/vehicle-type",
        element: <VehicleType />,
      },
      {
        path: ":category_id/vehicle-brand",
        element: <VehicleBrand />,
      },
      {
        path: ":category_id/select-vehicle",
        element: <SelectVehicle />,
      },
      // Wash details and cart
      {
        path: ":category_id/wash-details",
        element: <WashDetails />,
      },
      {
        path: ":category_id/cart",
        element: <Cart />,
      },
      // Slot booking
      {
        path: ":category_id/slot-book",
        element: <SlotBook />,
      },
      // Summary/Checkout
      {
        path: ":category_id/summary",
        element: <Summary />,
      },
      // Thanks page
      {
        path: ":category_id/thanks",
        element: <ThanksPage />,
      },
      // Subscription details
      {
        path: ":category_id/subscription/:subscription_id",
        element: <SubscriptionDetailsPage />,
      },
    ],
  },
  // Legacy routes for backward compatibility (redirect to new paths)
  {
    path: "/wash",
    element: <Navigate to="/carwash/4" replace />,
  },
  {
    path: "/wash/:category_id",
    element: <Navigate to="/carwash/:category_id" replace />,
  },
];

export default carWashRoutes;